// Вкладки с примерами на странице Стандартизации

import tabs from "./tabs";
import result from "../demo/result";
import utils from "../../utils";
import switchFromMotto from "../demo/switch-from-motto";

const template = `
<section class="storey clean-examples" >
    <div class="frow center-xs">
        <div class="col-xs-12 col-sm-6" >
            <div
                v-for="request in this.tabs[activeTab].examples"
                :key="request"
                class="clean-examples__request clean-examples__request--inactive"
            >
                [[ request ]]
            </div>
            <div class="clean-examples__request">[[ this.tabs[activeTab].defaultValue ]]</div>
            <div class="arrow-bottom"></div>
        </div>
    </div>
    <div
        class="clean-examples__animation"
        v-if="showTab"
        :class="[tabChanged?'clean-examples__animation--animated':'']"
    >
        <div
            class="frow clean-examples__wrapper"
            :class="[additionalFields?'':'center-xs clean-examples__wrapper--single']"
        >
            <div class="col-xs-12 col-sm-5 sheets__wrapper">
                <div class="sheets clean-examples__result">
                    <div class="sheet">
                        <result-item
                            data-ref="ex-qc"
                            v-if="result && result.qc > -1"
                            className="clean-examples__result-qc"
                        >
                            <span
                                class ="clean-demo-result__qc"
                                :class="qc.isCorrect ?
                                    'clean-demo-result__qc--true'
                                    : 'clean-demo-result__qc--false'"
                            >
                                [[ qc.text ]]
                            </span>
                        </result-item>
                        <result-item
                            v-if="result && qc_complete && result.qc != 2"
                            className="clean-examples__result-qc"
                        >
                            <span
                                class ="clean-demo-result__qc"
                                :class="qc_complete.isCorrect ?
                                    'clean-demo-result__qc--true'
                                    : 'clean-demo-result__qc--false'"
                            >
                                [[ qc_complete.text ]]
                            </span>
                        </result-item>
                        <div class="clean-examples__result-fields">
                            <template v-for="(label, index) in fields" :key="label">
                                <result-item
                                    v-if="result[index]"
                                    :label="label"
                                    :index="index"
                                    className="clean-examples__result-item"
                                    :keyClassMod = "activeTab"
                                    :showColon = "false"
                                >
                                    <div v-html="result[index]"></div>
                                </result-item>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-7 clean-examples__additional" v-if="additionalFields">
                <div class="clean-examples__additional-header">Дополнительные данные</div>
                <template v-for="(label, index) in additionalFields" :key="label">
                    <result-item
                        v-if="result[index]"
                        :label="label"
                        :index="index"
                        className="clean-examples__result-item"
                        keyClassMod = "add"
                        :showColon = "false"
                    >
                        <div v-html="result[index]"></div>
                    </result-item>
                </template>
            </div>
        </div>
    </div>
    <div class="frow" :class="[additionalFields?'':'center-xs']">
        <div class="col-xs-12 col-sm-8 clean-examples__bottom">
            В «Стандартизацию» массово загружают контакты: например,<br/> клиентскую базу целиком. 
            Сервис обрабатывает 10 000 записей за 15 минут
        </div>
    </div>
</section>`;

const data = function () {
    return {
        tabs,
        activeTab: "address",
        result: null,
        tabChanged: false,
        showTab: true,
    };
};

const methods = {
    setActiveTab(index) {
        const oldActiveTab = this.activeTab;
        if (oldActiveTab === index) {
            return;
        }
        if (index in this.tabs) {
            this.showTab = false;
            this.tabChanged = true;
            this.activeTab = index;
            this.initTab();
        }
    },

    initTab() {
        this.result = this.tabs[this.activeTab].result;
        this.setExamplesFields();
        this.$nextTick(() => { this.showTab = true; });
    },

    setExamplesFields() {
        this.setFields();
        if (!this.additionalFields) {
            return;
        }
        this.deleteUnwantedFields();
        this.putFieldInTheEnd("output_metro", this.additionalFields);

        if ("output_geo" in this.additionalFields) {
            this.result.output_geo = utils.stripTags(this.result.output_geo);
        }

        if ("fias_level_name" in this.additionalFields) {
            const regexp = /\((.*?)\)/;
            const value = this.result.fias_level_name.match(regexp)[1];
            if (value) {
                this.result.fias_level_name = value[0].toUpperCase() + value.substring(1);
            }
        }
    },

    deleteUnwantedFields() {
        const unwantedFields = ["fias_actuality_state_name", "iso_codes"];
        unwantedFields.forEach(field => {
            if (field in this.additionalFields) {
                delete this.additionalFields[field];
            }
        });
    },

    putFieldInTheEnd(field, object) {
        if (field in object) {
            const fieldCopy = object[field];
            delete object[field];
            object[field] = fieldCopy;
        }
    },
};

const mounted = function () {
    this.initTab();
};

const mixins = [result, switchFromMotto];

export default {
    data,
    template,
    methods,
    mixins,
    mounted,
};
